import { apiURL } from '../config';
import { ContactUsFormData, ContacUsFormResponse } from '../models/contactUs';

export const fetchContactUs = async (
  formData: ContactUsFormData
): Promise<ContacUsFormResponse> => {
  try {
    const res = await fetch(`${apiURL}contacts`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ...formData }),
    });
    return await res.json();
  } catch (e) {
    return await Promise.reject(e);
  }
};
